<template>
  <div id="personal-info-wrap">
    <div class="container">
      <div class="header">
        <button @click="toListPage">跳过</button>
      </div>
      <div class="main">
        <p>请完善您的个人信息</p>
        <div class="main-content">
          <p>姓名</p>
          <div class="item item-username">
            <div><img src="../assets/image/Vcar_PersonalInformation/username.png"></div>
            <input type="text" v-model="name" placeholder="请填写您的真实姓名" @blur="blur" maxlength="20">
          </div>
          <p>公司</p>
          <div class="item item-company">
            <div><img src="../assets/image/Vcar_PersonalInformation/company.png"></div>
            <input type="text" v-model="company" placeholder="请填写您的公司名称" @blur="blur" maxlength="32">
          </div>
          <p>职位</p>
          <div class="item item-postion">
            <div><img src="../assets/image/Vcar_PersonalInformation/postion.png"></div>
            <input type="text" v-model="jobs" placeholder="请填写您的职位" @blur="blur" maxlemgth="20">
          </div>
        </div>
      </div>
      <div class="footer">
        <button @click="submitInfo">提交</button>
      </div>
    </div>
  </div>
</template>

<script>
  import common from '../utils/common'
  import constants from '../utils/constants'

    export default {
      name: "Vcar_PersonalInformation",
      data(){
        return {
          name: null,
          company: null,
          jobs: null
        }
      },
      created(){
      },
      mounted(){
        window.scrollTo(0, 0)
        const vm = this
        vm.$nextTick(function () {
          /* 判断是否有手机号码 */
          if (common.isEmpty(sessionStorage.getItem("mobile"))) {
            common.redirect(vm, 'vcar_login')
          }
          /* 微信分享 */
          common.wxShare(vm, constants.VC_SHAREINFO)
        })
      },
      methods: {

        /* 跳过 */
        toListPage() {
          common.redirect(this, 'vcar_list')
        },
        /* 页面回弹 */
        blur(e){
          common.blurPageScroll()
        },
        /* 提交 */
        submitInfo(){
          const that = this
          if(common.isEmpty(common.trimAll(that.name))) {
            common.tipToast('请填写姓名')
            return
          }
          if(common.isEmpty(common.trimAll(that.company))) {
            common.tipToast('请填写公司名称')
            return
          }
          if(common.isEmpty(common.trimAll(that.jobs))) {
            common.tipToast('请填写您的职位')
            return
          }
          let obj = {}
          obj.name = common.trimAll(that.name)
          obj.company = common.trimAll(that.company)
          obj.jobs = common.trimAll(that.jobs)
          obj.username = sessionStorage.getItem("username")
          /* 提交填写资料 */
          that.$axios({
            method: 'put',
            url: '/admin/user/edit',
            data: obj,
            headers: {
              'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
            },
          }).then(function (res) {
            sessionStorage.setItem('userInfoFlag', true)
            sessionStorage.setItem('customerName', common.trimAll(that.name))
            that.toListPage()
            common.tipToast(res.data.msg)
            return
          }).catch(function (error) {
            common.tipToast(error.data.msg)
            return
          })
        }
      }
    }
</script>

<style scoped>
  p,div,sup {
    font-family: "PingFang SC";
  }

  #personal-info-wrap {
    width: 100vw;
    background-color: #fff;
  }

  .container {
    margin: 0 auto;
    width: 7.5rem;
    /*height: 100vh;*/
  }

  #login-wrap > .container {
    margin: 0 auto;
    width: 7.5rem;
  }

  .container > .header {
    /*border: 1px solid black;*/
    height: 0.93rem;
    display: flex;
    align-items: center;
    text-align: right;
    justify-content: flex-end;
  }
  .container > .header > button {
    padding: 0 0.45rem;
    height: 0.45rem;
    line-height: 0.45rem;
    font-size: 0.32rem;
    color: #000000;
    background-color: #fff;
    border-width: 0;
    outline: 0;
    letter-spacing: -0px;
    text-align: right;
  }

  .container > .main {
    margin: 0 auto;
    margin-top: 0.21rem;
    width: 5.655rem;
  }

  .main > p:first-child {
    font-size: 0.44rem;
    font-weight: 500;
    line-height: 0.62rem;
    color: #000000;
    letter-spacing: -0px;
    text-align: left;
  }

  .main-content {
    margin-top: 1.09rem;
  }

  .main-content > p {
    margin-top: 0.89rem;
    font-size: 0.40rem;
    font-weight: 500;
    line-height: 0.56rem;
    color: #000000;
    letter-spacing: -0px;
    text-align: left;
  }
  .main-content > p:first-child {
    margin-top: 0;
  }

  .main-content > .item {
    position: relative;
    margin-top: 0.2rem;
    border-bottom: 0.01rem solid #979797;
    width: 5.655rem;
    height: 0.82rem;
    font-size: 0;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }

  .main-content > .item > div {
    position: absolute;
    top:0;
    left: 0;
    width: 0.65rem;
    height: 0.82rem;
    font-size: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .main-content > .item-company > div > img {
    width: 0.38rem;
    height: 0.38rem;
  }

  .main-content > .item-username > div > img {
    width: 0.42rem;
    height: 0.42rem;
  }

  .main-content > .item-postion > div > img {
    width: 0.42rem;
    height: 0.40rem;
  }

  .main-content > .item > input {
    padding: 0;
    padding-left: 0.92rem;
    width: 100%;
    height: 0.78rem;
    line-height: 0.42rem;
    border: 0;
    font-size: 0.30rem;
    color: #000000;
    letter-spacing: -0px;
    outline: none;
    text-align: left;
  }

  .container > .footer {
    margin-top: 2.55rem;
    padding-bottom: 1.98rem;
    width: 100%;
    text-align: center;
  }

  .container > .footer > button {
    margin: 0 auto;
    padding: 0;
    width: 5.80rem;
    height: 1rem;
    display: block;
    background-image: linear-gradient(90deg, #195EDB 0%, #2594FE 100%);
    border-radius: 0.5rem;
    border-width: 0;
    outline: none;
    font-size: 0.32rem;
    color: #FFFFFF;
    letter-spacing: -0px;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/Vcar_PersonalInformation.vue